import { useCreateInitialScriptState } from '@/components/Event/NewScript/hooks/state/useCreateInitialScriptState'
import { EventType } from '@/constants'
import { Event } from '@/types'

// note: this is duplicated on backend, if you are changing it here, remember to
// update it there as well
const TRAINING_EVENT_TYPES = [
  EventType.DEPOSITION,
  EventType.EXAMINATION_UNDER_OATH,
]
const TRAINING_EVENT_ID_RE = new RegExp(
  'training' +
    '(?:-(?<silo>cr))?' +
    '(?:-(?<multiwitness>multiwitness))?' +
    `(?:-(?<event_type>${TRAINING_EVENT_TYPES.map(et => et.replaceAll('_', '-')).join('|')}))?` +
    '(?:-(?<state>[A-Z]{2}))?' +
    '-event',
)

export const useNewScriptTraining = (event?: Event) => {
  const { initScriptData, isLoading } = useCreateInitialScriptState({
    event,
  })
  const hasTrainingAccess = TRAINING_EVENT_ID_RE.test(event?.id ?? '')

  const resetScript = () => {
    if (!event) {
      return
    }

    return initScriptData()
  }

  return { hasTrainingAccess, resetScript, isResetting: isLoading }
}
